<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" persistent max-width="80vw">
          <!-- Кнопка вызова диалогового окна -->
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="warning" dark v-bind="attrs" v-on="on">
              Создать новость
            </v-btn>
          </template>
          <!-- Форма создания комплектубщей -->
          <v-card>
            <v-card-title>
              <span class="headline">Новая новость</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Заголовок"
                      required
                      v-model="title"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-file-input
                      show-size
                      counter
                      label="Изображение"
                      v-model="image"
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      label="Текс новости"
                      v-model="text"
                      hint="Краткость — сестра таланта"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false"
                >Закрыть</v-btn
              >
              <v-btn color="warning" dark @click="send_news()">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog_edit" persistent max-width="80vw">
          <!-- Кнопка вызова диалогового окна -->
          <!-- Форма создания комплектубщей -->
          <v-card>
            <v-card-title>
              <span class="headline">Новая новость</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Заголовок"
                      required
                      v-model="title_2"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="6" md="6">
                    <v-img :src="image_2" height="200px"></v-img>
                    
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-file-input
                      show-size
                      counter
                      label="Изменить"
                      @change="upload_file"
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-file-input
                      show-size
                      counter
                      label="Изображение"
                      @change="ranis"
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      label="Текс новости"
                      v-model="text_2"
                      hint="Краткость — сестра таланта"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog_edit = false"
                >Закрыть</v-btn
              >
              <v-btn color="warning" dark @click="update_n()">Сохранить</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <News :news="get_news" @item="on_news" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";

import { mapGetters, mapActions } from "vuex";
import News from "@/components/News.vue";

export default {
  name: "NewsList",
  data() {
    return {
      title: null,
      text: null,
      dialog: false,
      dialog_edit: false,
      image: null,
      title_2: null,
      text_2: null,
      image_2: null,
      upload: null,
      news_id: null,
    };
  },
  props: ["item"],
  components: {
    News,
  },
  created() {
    this.load_news_by_authorize();
  },
  computed: {
    ...mapGetters(["get_news", "get_baseURL"]),
  },
  methods: {
    ranis(e) {
      if (e) {
        this.image_2 = e.name;
        this.upload = e;
      }
    },
    upload_file(e) {
      let reader = new FileReader();
      
      reader.readAsDataURL(e);
      reader.onload = function () {
        this.image_2 = reader.result;
      };

      
    },
    on_news(item) {
      this.title_2 = item.title;
      this.text_2 = item.text;
      this.dialog_edit = true;
      this.image_2 = `/images/news/${item.image}`;
      this.news_id = item._id;
    },

    ...mapActions(["load_news_by_authorize", "set_news", "edit_news"]),
    async upload_image(type) {
      let formData = new FormData();

      type == "create"
        ? formData.append("file", this.image)
        : formData.append("file", this.upload);

      const instance = await axios.create({
        baseURL: this.get_baseURL,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: localStorage.getItem("_token"),
        },
      });

      instance
        .post(`/news/image`, formData)
        .then((response) => response.data)
        .then((data) => {
          if (type == "create") {
            this.set_news({
              news: { title: this.title, text: this.text, image: data.name },
            }).then(() => {
              this.title = null;
              this.text = null;
              this.dialog = false;
              this.dialog = null;
              this.image = null;
            });
          } else {
            this.edit_news({
              news: {
                title: this.title_2,
                text: this.text_2,
                image: data.name,
                _id: this.news_id,
              },
            })
              .then(() => {
                this.title_2 = null;
                this.text_2 = null;
                this._id = null;
                this.dialog_edit = false;
                this.dialog_edit = null;
              })
              .catch((err) => {
                console.log(err);
              });
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },

    send_news() {
      if (!this.title && !this.text) return false;

      if (this.image) this.upload_image("create");
      else
        this.set_news({
          news: { title: this.title, text: this.text },
        }).then(() => {
          this.title = null;
          this.text = null;
          this.dialog = false;
          this.dialog = null;
          this.image = null;
        });
    },

    update_n() {
      if (!this.title_2 && !this.text_2) return false;
      if (this.upload) this.upload_image("update");
      else
        this.edit_news({
          news: {
            title: this.title_2,
            text: this.text_2,
            _id: this.news_id,
          },
        }).then(() => {
          this.title_2 = null;
          this.text_2 = null;
          this._id = null;
          this.dialog_edit = false;
        });
    },

    dataURLtoFile(dataurl) {
      if (!dataurl) return false;

      let u8arr = [];

      if (dataurl)
        return new File([u8arr], dataurl, { type: "data:image/png;base64" });
    },
  },
};
</script>

<style scoped>
.upload-images-item__image {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center center;
}
</style>
